export default {
  'build.info': 'Build Info',
  'build.mode': 'Mode',
  'build.framework': 'Framework',
  'build.os': 'Operation System',
  'build.osPlatform': 'Platform',
  'build.osRelease': 'Release',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.system': 'System',
  'theme.tooltip': 'Theme',
};
